import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const providerSelectionsApiRoutes = {
    get: apiBusSchedBaseURL + "bussched/providerselection/",
    getTml: apiBusSchedBaseURL + "bussched/providerselection/tml/",
    update: apiBusSchedBaseURL + "bussched/providerselection/",
    updateTml: apiBusSchedBaseURL + "bussched/providerselection/tml/",
};

export class ProviderSelectionAPI {
    static get() {
        const url = providerSelectionsApiRoutes.get;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    };

    static getTml() {
        const url = providerSelectionsApiRoutes.getTml;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    };

    static getTmlData(type, code) {
        const url = new URL(`${type}/${code}`, providerSelectionsApiRoutes.getTml);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static update(selections) {
        const url = providerSelectionsApiRoutes.update;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(selections)
        });
    }

    static updateTml(selections) {
        const url = providerSelectionsApiRoutes.updateTml;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(selections)
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/bussched/ProviderSelectionAPI.js